/**
 * QA climber provisioning (/hldebug/provision-user). Mirrors the internal tools
 * AppSync schema (packages/server/cdk/internal-tools-appsync-schema.gql).
 */

export type QaProvisionJobStatus =
  | "PENDING"
  | "RUNNING"
  | "SUCCEEDED"
  | "PARTIAL"
  | "FAILED";

/** Terminal statuses — polling stops here. */
export const QA_JOB_FINISHED: QaProvisionJobStatus[] = [
  "SUCCEEDED",
  "PARTIAL",
  "FAILED",
];

export interface QaProvisionProgress {
  /** The climber `detail` belongs to, not a position in the batch. */
  userIndex?: number | null;
  userCount?: number | null;
  /** Climbers finished so far — climbers run concurrently. */
  usersDone?: number | null;
  phase?: string | null;
  line?: number | null;
  done?: number | null;
  total?: number | null;
  detail?: string | null;
}

export interface QaProvisionEvent {
  ts?: string | null;
  level?: string | null;
  message?: string | null;
  userIndex?: number | null;
}

export interface QaProvisionUser {
  index: number;
  status: string;
  climberId?: string | null;
  username?: string | null;
  password?: string | null;
  applied?: number | null;
  skipped?: string[] | null;
  error?: string | null;
}

export interface QaProvisionJob {
  jobId: string;
  status: QaProvisionJobStatus;
  createdAt?: string | null;
  updatedAt?: string | null;
  mode?: string | null;
  productCode?: string | null;
  entryCount?: number | null;
  error?: string | null;
  progress?: QaProvisionProgress | null;
  events?: QaProvisionEvent[] | null;
  users?: QaProvisionUser[] | null;
}

export interface StartQaProvisionJobInput {
  sectionIds: string[];
  manifestText: string;
  count?: number;
  firstName?: string;
  lastName?: string;
  password?: string;
}
